import { Label } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { Col, DatePicker, Row, Modal } from 'antd';
import { Page } from '@4beefopag/4bee-fopag-core/dist/organisms';
import fileDownload from 'js-file-download';
import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import BwgButton from '../../atoms/Button';
import SelectFolha from '../../atoms/SelectFolha';
import SelectRelacionamento from '../../atoms/SelectRelacionamento';
import { downloadDismissedCooperatorsReport } from '../../../services/repository/cooperatorRepository';
import { useAccessibleCompanies } from '../../../services/repository/companyRepository';
import { handleDownloadWithMetrics } from '../../../services/util/file';
import {
  filterCompaniesByRelationships,
  resolveDismissedReportCompanyIds,
} from './dismissedReportFilters';

const ActionButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 24px;
`;

const FormContainer = styled.div`
  padding: 24px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

const DISPLAY_DATE_FORMAT = 'DD/MM/YYYY';

function InactiveCooperators() {
  const navigate = useNavigate();
  const [selectedRelationships, setSelectedRelationships] = useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [period, setPeriod] = useState([]);
  const { data: allCompanies = [], isPending: isCompaniesPending } = useAccessibleCompanies();

  const relationshipOptions = useMemo(
    () => [...new Set(allCompanies.map((company) => company.relacionamento).filter(Boolean))],
    [allCompanies]
  );

  const folhaOptions = useMemo(
    () => filterCompaniesByRelationships(allCompanies, selectedRelationships),
    [allCompanies, selectedRelationships]
  );

  const handleRelationshipsChange = (nextRelationships) => {
    setSelectedRelationships(nextRelationships);
    setSelectedCompanies([]);
  };

  const onGenerateReport = () => {
    handleDownloadWithMetrics(
      async () => {
        const companyIds = resolveDismissedReportCompanyIds({
          selectedCompanies,
          selectedRelationships,
          allCompanies,
        });

        const blob = await downloadDismissedCooperatorsReport({
          startDate: period[0],
          endDate: period[1],
          companyIds,
        });
        fileDownload(blob, 'relatorio-afastados.xlsx');

        Modal.success({
          title: 'Sucesso',
          content: <p>Relatório gerado com sucesso!</p>,
        });
      },
      {
        key: 'cooperator.export-dismissed-report',
        source: 'cooperator.report.dismissed-removed',
      }
    );
  };

  return (
    <Page
      projeto="Cooperativa"
      titulo="Relatórios de Afastados"
      linkManual={process.env.REACT_APP_LINK_MANUAL}
    >
      <FormContainer>
        <Row gutter={[24, 24]}>
          <Col
            xs={24}
            md={8}
          >
            <SelectRelacionamento
              value={selectedRelationships}
              onChange={handleRelationshipsChange}
              relacionamentos={isCompaniesPending ? undefined : relationshipOptions}
            />
          </Col>

          <Col
            xs={24}
            md={8}
          >
            <SelectFolha
              isMulti
              showLabel
              placeholder="Selecione..."
              folhaSelecionada={selectedCompanies}
              onChange={setSelectedCompanies}
              folhas={isCompaniesPending ? undefined : folhaOptions}
            />
          </Col>

          <Col
            xs={24}
            md={8}
          >
            <Label label="Período">
              <DatePicker.RangePicker
                style={{ width: '100%' }}
                format={DISPLAY_DATE_FORMAT}
                value={period}
                onChange={setPeriod}
                allowEmpty={[true, true]}
              />
            </Label>
          </Col>
        </Row>

        <ActionButtonsContainer>
          <BwgButton onClick={() => navigate(-1)}>Fechar</BwgButton>
          <BwgButton
            type="primary"
            onClick={onGenerateReport}
          >
            Gerar Relatório
          </BwgButton>
        </ActionButtonsContainer>
      </FormContainer>
    </Page>
  );
}

export default InactiveCooperators;
